
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguagePath } from "@/utils/language";

export const SessionHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslations("student-sessions");
  const { getPath } = useLanguagePath();
  
  return (
    <Button 
      onClick={() => navigate(getPath("/student-dashboard/training-sessions/new"))} 
      className="bg-flame text-white hover:bg-flame/90 rounded-xl shadow-md hover:shadow-lg transition-all flex items-center gap-2"
    >
      <Plus className="h-4 w-4" />
      {t("actions.newSession")}
    </Button>
  );
};
